goog.provide('el8.ptdata.familyRelationshipItems');

goog.require('el8.model.base');
goog.require('el8.template.ptdata.familyRelationshipItems');


el8.ptdata.familyRelationshipItems = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.addStringProperty('text', true);
    _class.addIntProperty('snomedId', true);
    _class.addIntProperty('icd9Id', true);
    _class.addIntProperty('relationshipId', true);
    _class.addIntProperty('rank');

    _class.prototype.getSnomedObj = function() {
        var snomedId = this.getSnomedId();
        if (!snomedId) { return null; }

        return el8.data.snomedCodes.getById(snomedId);
    };
    _class.prototype.getIcd9Obj = function() {
        var icd9Id = this.getIcd9Id();
        if (!icd9Id) { return null; }

        return el8.data.icd9Codes.getById(icd9Id);
    };
    _class.prototype.getSnomedCode = function() {
        var snomed = this.getSnomedObj();
        return (snomed) ? snomed.getCode() : null;
    };
    _class.prototype.getIcd9Code = function() {
        var icd9 = this.getIcd9Obj();
        return (icd9) ? icd9.getCode() : null;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        // this is also calculated on the server for print forms
        var textOrCodeDescription = this.getText();
        var snomed = this.getSnomedObj();
        var icd9 = this.getIcd9Obj();
        if (snomed) {
            textOrCodeDescription = snomed.getDescription();
        } else if (icd9) {
            textOrCodeDescription = icd9.getDescription();
        }
        mapped['textOrCodeDescription'] = textOrCodeDescription;

        var relationship = el8.ptdata.ptFamilyRelationships.getById(this.getRelationshipId());
        mapped['relationshipTypeName'] = relationship.getRelationshipTypeName();

        return mapped;
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.familyRelationshipItems.noteSummary(this.asSoyMap()).el8_unescape();
    };


    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },

        sortFn: function(a, b){ return a.getRank()-b.getRank(); },

        saveFn: function(item, successCallbackFn, errorCallbackFn, opts) {
            $.el8_ajax({
                type: 'POST',
                async: opts ? (opts.async !== false) : true,  // defaults to true
                url: el8.service.urls.get('familyRelationshipItem', [item]),
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.familyRelationshipItems.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    
                    // the list of itemIds in our relationship will be out of sync if we don't do this:
                    el8.ptdata.ptFamilyRelationships.create(data.relationship, true);
                    
                    el8.appservice.notifier.notify('Structured family history item saved.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
            return item;
        },

        deleteFn: function(item, successCallbackFn) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('familyRelationshipItem', [item]),
                success: function(data) {
                    // the list of itemIds in our relationship will be out of sync if we don't do this:
                    el8.ptdata.ptFamilyRelationships.create(data.relationship, true);

                    if (successCallbackFn) { successCallbackFn(data); }
                }
            });
        }
    });

    return that;

})();
